import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import ItemContents from './ItemContents';
import ItemMarketplaceDetails from './ItemMarketplaceDetails';
import ItemRecipient from './ItemRecipient';
import { EditType } from './EditType';
import { SmartSendItemSelect } from '../SmartSendItemSelect';
import { P2GAlert, P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { EventSections } from '../../../lib/events/EventLogger';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  item: SmartSendItemApiModel;
  cancel: () => void;
  isReturn: boolean;
}

export default function SmartSendItemProcessing(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const edit = (_: EditType) => {};
  return (
    <div>
      <P2GBox p={1}>
        <SmartSendItemSelect selected={props.item.State.selected} toggle={() => {}}>
          <P2GGrid container spacing={1}>
            <P2GGrid item xs={12} sm={6} md={4}>
              <ItemContents edit={edit} item={props.item} variant="body2" />
            </P2GGrid>
            <P2GGrid item xs={12} sm={6} md={3}>
              <ItemRecipient
                edit={edit}
                customer={props.isReturn ? props.item.Sender : props.item.Recipient}
                variant="body2"
              />
            </P2GGrid>
            <P2GGrid item xs={12} sm={6} md={5}>
              <P2GAlert palette="primary">
                <P2GText variant="body2">
                  {t('PAYMENT_STARTED_EXTERNALLY_INFO', {
                    defaultValue: 'You have started to pay for this externally...'
                  })}
                </P2GText>
                <P2GLinkGroup
                  pb={0}
                  pt={1}
                  links={[
                    <P2GLink key="release" onClick={props.cancel}>
                      {t('RELEASE_LINK', { defaultValue: 'Release' })}
                    </P2GLink>
                  ]}
                />
              </P2GAlert>
            </P2GGrid>
          </P2GGrid>
        </SmartSendItemSelect>
      </P2GBox>
      <ItemMarketplaceDetails section={EventSections.SmartSend} item={props.item} removeTag={null} saveTags={null} />
    </div>
  );
}
